import './instrument'

import * as ReactDOM from 'react-dom/client'
import { toast } from 'react-hot-toast'
import { initReactI18next } from 'react-i18next'

import axios from 'axios'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

import { App } from './app/app'
import env from './environments'
import reportWebVitals from './reportWebVitals'
import { logout } from './utils/auth'
import { versionStore } from './utils/versionStore'

/**
 * AXIOS CONFIG
 */
axios.defaults.withCredentials = true

axios.interceptors.response.use(
	response => response,
	async error => {
		if (error?.response?.status === 401 && error?.response?.data?.error !== 'plan_limit_reached') {
			await logout()
			toast.error('Session expired, please login again')
		}

		throw error
	}
)

axios.interceptors.response.use(response => {
	const backendVersion = response.headers['x-app-version']

	if (env.version !== '__VERSION__' && typeof backendVersion === 'string' && backendVersion !== env.version) {
		versionStore.setDetected()
	}

	return response
})

/**
 * TRANSLATE CONFIG
 */
i18n.use(Backend)
	.use(initReactI18next)
	.init({
		debug: true,
		fallbackLng: 'fr',
		lng: localStorage.getItem('lng') ?? 'fr',
		backend: {
			loadPath(lang: string, ns: string) {
				return `assets/locales/${lang}/${ns}.json`
			}
		},
		ns: [
			'app',
			// Auth translation
			'auth/login',
			'auth/newPassword',
			'auth/reset',
			'auth/signup',
			// Cartography translation
			'cartography/cartography',
			'cartography/classic',
			'cartography/filters',
			'cartography/quick-menu',
			'cartography/share',
			// Components translation
			'components/changePassword',
			// Layouts translation
			'layouts/navbar',
			'layouts/sidebar',
			// Public translation
			'public/public',
			// Relationships translation
			'relationships/import',
			'relationships/relationships',
			'relationships/relationshipsContent',
			'relationships/settings',
			// Workspace translation
			'workspace/connectors',
			'workspace/import',
			'workspace/nodes',
			'workspace/settings',
			'workspace/sharing',
			'workspace/workspace'
		],
		detection: {
			order: ['localStorage', 'lng'],
			lookupQuerystring: 'lng',
			lookupLocalStorage: 'lng',
			caches: ['localStorage']
		}
	})

/**
 * FONT AWESOME CONFIG
 */
library.add(fas, fab, far)

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
	// <React.StrictMode>
	<App />
	// </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// amplitude.init('a13fd1e83199bf7d3222566ae2a10ace', undefined, { defaultTracking:
// 		{
// 			sessions: true, pageViews: true, formInteractions: true, fileDownloads: true
// 		}
// }
// )
